<template>
  <div class="cmp-accounting-costs-costs_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddCostClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <Dropdown
          style="margin-left: 20px; margin-right: 20px; width: 150px"
          :options="costGroupTV"
          :selected="
            costGroupTV.find((e) => e.value == basicFilter.cost_group_id)
          "
          :placeholder="$t('select_cost_group')"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('cost_group_id', e)"
        ></Dropdown>
        <Dropdown
          style="margin-right: 20px; width: 200px"
          :options="invoice_projectsTV"
          :selected="
            invoice_projectsTV.find(
              (e) => e.value == basicFilter.invoice_project_id
            )
          "
          :placeholder="$t('select_invoice_project')"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
        ></Dropdown>
        <Dropdown
          style="margin-right: 20px; width: 150px"
          :options="inv_statTV"
          :listHeight="260"
          :selected="
            inv_statTV.filter((e) =>
              (basicFilter.status_colors || '')
                .split(',')
                .includes(`${e.value}`)
            )
          "
          :placeholder="$t('select_status')"
          :title="$t('select_status')"
          multiple
          allnone
          borderbottom
          v-on:selectedChange="(e) => onMultiDropdownChange('status_colors', e)"
        ></Dropdown>
        <DTIconButton
          :classNames="'search--advanced'"
          :text="$t('advanced_search')"
          :style="{
            minWidth: '148px',
            maxWidth: '148px',
          }"
          icon="add-blue"
          @click="onAdvancedSearchClick"
        />
      </div>
    </div>
    <div class="dt-page--2nd-bar" v-if="isSearchFilterActive">
      <div class="search-config--container">
        <div class="search-config">
          <SearchConBadge
            v-for="sconKey of filteredAdvancedSearchConfigKeys"
            :key="sconKey"
            v-bind="searchConfigKey(sconKey)"
            @delete="onSearchConDelete"
          />
        </div>
      </div>
    </div>
    <button
      :disabled="batchPDFDownloadLoading"
      @click="batchPDFDownloadRequest"
      class="dt-button v5 s8"
      :class="batchPDFDownloadLoading ? 'disabled' : ''"
      style="width: 100px; margin-left: 35px; margin-top: 10px"
      v-if="checkedCostsID.length > 0"
    >      
      {{ $t("batch_pdf_download") }}
    </button>
    <div
      class="dt-page--body"
      :style="{ '--offset': `${isSearchFilterActive ? `156px` : `120px`}` }"
    >
      <NTable
        :id="'accounting-costs-costs_list'"
        class="costs-list h1"
        :headers="headers"
        :config="tableConfig"
        :items="list"
        ref="costListTable"
        :loadingFlag="loadingFlag"
        @scrollnext="onListScroll"
      >
        <template v-slot:thead="{ thcon, thtext }">
          <tr>
            <th
              v-for="header in headers"
              v-bind="thcon(header.value)"
              :key="header.value"
            >
              <div
                style="padding-bottom: 5px"
                v-if="['left_options'].includes(header.value)"
                class="header-name"
              >
                <div class="check-buttons">
                  <img
                    style="height: 18px; width: 18px"
                    @click="(e) => onHeaderCheckboxChanged(e)"
                    :src="`static/icons/arrows/${headerCheckboxIcon}-accent.svg`"
                    class="dt-icon checkbox"
                  />
                </div>
              </div>
              <span v-else class="header-name">
                {{ thtext(header.value) }}
              </span>
            </th>
          </tr>
        </template>
        <template v-slot:item="{ item, tdcon }">
          <tr  @click="(e) => onCostClicked(e, item)">
            <td v-bind="tdcon('left_options')">
              <div class="dt-checkbox v2 s1" style="margin: auto 5px">
                <input
                  type="checkbox"
                  class="invoice-select-cb"
                  @click="(e) => onSelectCost(e, 'cost', item)"
                  :checked="checkedCostsID.includes(item.invoice_id)"
                />
                <div class="checkmark"></div>
              </div>
            </td>
            <td v-bind="tdcon('main_costs')">
              <div class="ut-flex">
                <div
                  class="circle"
                  :style="{
                    backgroundColor: `${getInCoStatusColor(item['status_textkey'])}`,
                  }"
                ></div>

                <div
                  style="margin-left: 10px"
                  class="txtov"
                  :title="item.external_ref"
                >
                  {{ item["external_ref"] }}
                </div>
              </div>
            </td>
            <td v-bind="tdcon('creditor')">
              <span :title="item.full_name" class="txtov">{{
                item["full_name"]
              }}</span>
            </td>
            <td v-bind="tdcon('date_string')">
              <span :title="item.invoice_date" class="txtov">{{
                item["invoice_date"]
              }}</span>
            </td>
            <td v-bind="tdcon('costgroups')">
              <span :title="item.cost_group_name" class="txtov">{{
                item["cost_group_name"]
              }}</span>
            </td>
            <td v-bind="tdcon('main_subject')">
              <span :title="item.subject" class="txtov">{{
                item["subject"]
              }}</span>
            </td>
            <td v-bind="tdcon('amount_net')">
              <span :title="item.currency_iso" class="txtov"
                >{{ item["net_amount_cc"] }} {{ item["currency_iso"] }}</span
              >
            </td>
            <td v-bind="tdcon('printer')">
              <div style="display: flex">
                <div class="dt-icon-container">
                  <img
                    v-if="
                      singlePDFDownloadingID > 0 &&
                      singlePDFDownloadingID == item.invoice_id
                    "
                    src="static/icons/loading.gif"
                    alt
                    style="height: 10px; width: 10px; margin: 0px 10px"
                  />
                  <img
                    v-else
                    @click.stop="(e) => onInvoicePDFClick(item)"
                    src="static/icons/pdf.svg"
                    class="dt-icon v5 s2"
                    alt
                    :title="`${$t('pdf')}`"
                  />
                </div>
                <div class="dt-icon-container">
                  <img
                    @click.stop="(e) => onInvoicePrintClick(item)"
                    src="static/icons/printer.svg"
                    class="dt-icon v5 s2"
                    alt
                    :title="`${$t('print')}`"
                  />
                </div>
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="(e) => onCostDelete(item)"
                class="dt-icon v5 s2"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <div class="account-list-footer">
      <DtPageStatusFloat
        :statusTV="
          inv_statTV.map((tv) => ({
            ...tv,
            value: `${getInvoiceStatColor(tv.value)}`,
          }))
        "
      />
    </div>
    <Sidewindow
      :navConfig="defaultConfig"
      :value="costDetailsFlag"
      @closed="onCloseCostDetails"
    >
      <CostSidewindow />
    </Sidewindow>
    <ModalContainer :modalKey="'newCost'" :width="'small'">
      <!-- :costData="costData" -->
      <NewCost @cancelled="onDialogCancelled" @added="onAdded" />
    </ModalContainer>
    <ModalContainer :modalKey="'advancedSearch'" width="small">
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @search="onAdvancedSearch"
        @cancelled="onAdvancedSearchCancelled"
      />
    </ModalContainer>
  </div>
</template>

<script>
import {
  getInvoiceStatColor,
  getInCoStatusColor,
} from "../../models/color-status";
import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import InputField from "@plugins/text-field/input-field";
import {
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";
import * as ActionTypes from "../../store/types";
import { AccountingStoreNamespace as storeNS } from "../../store";

import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import ModalContainer from "@dtplugins/modal/modal-container";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import {
  getCostDetailsSelectable,
  costListLDTRoutes,
} from "../../router/routes";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { costsActions } from "../../store/costs/actions";
import { costsGetters } from "../../store/costs/getters";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { CostsService } from "../../services/costs.service";
import { DTIconButton } from "../../../../plugins/button/button";
import { createTV, tv } from "../../../../models/text-value.model";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import CostSidewindow from "./sidewindow";
import NewCost from "./add-new-cost.vue";
import { HttpClient } from "../../../../services/http/http-client";
import {
  ConfirmationService,
  createConfirmResult,
} from "@/dt-plugins/confirmation/confirmation.service";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";

import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { createSubmoduleListMixin } from "../../../../dt-plugins/submodule-list/submodule-list.mixin";
import AdvancedSearch, {
  costListAdvancedSearchConfig,
} from "./advanced-search.vue";
import { openWindow, createMailHref, downloadPDF } from "../../../../utility";

import { InvoicesService } from "../../services/invoices.service";

const LDTConfig = {
  entityName: "invoice",
  ldtRoutes: costListLDTRoutes,
  detailsSelectableFunction: getCostDetailsSelectable,
  primaryKey: "invoice_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.CostsDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.CostsDetails.FETCH.SINGLE,
};

export default {
  props: "dropdownProps",
  components: {
    ModalContainer,
    NTable,
    InputField,
    DTCheckbox,
    DTIconButton,
    DtPageStatusFloat,
    AdvancedSearch,

    CostSidewindow,
    NewCost,
  },
  mounted: async function () {
    this.fetchCostData();
  },
  data: () => ({
    defaultConfig: defaultConfig,
    getCostDetailsSelectable: getCostDetailsSelectable,
    selectedClickedInvoice: null,
    selectedCostStatuses: [],
    selectedStatusColor: "",
    selectedCostGroup: null,
    singlePDFDownloadingID: 0,
    checkedCostsID: [],
    batchPDFDownloadLoading: false,
    // costData: null,
  }),
  mixins: [
    createLDTHost(LDTConfig),
    createModalMixin("newCost"),

    // FetchList and Advanced Search Mixin
    createModalMixin("advancedSearch"),
    createFetchListMixin(ActionTypes.CostsList.FETCH.ALL, 100),
    createAdvancedSearchHost(costListAdvancedSearchConfig),
  ],
  computed: {
    ...mapGetterObject(storeNS, costsGetters),
    headerCheckboxIcon: function () {
      return this.checkedCostsID.length == this.list.length
        ? "checkbox-tick"
        : this.checkedCostsID.length == 0
        ? "checkbox"
        : "checkbox-minus";
    },
    getCostStatColor(payload = "") {
      console.log(payload);
      const color_map = {
        "4A6CBA": "4A6CBA",
        "5ABFBF": "5ABFBF",
        F0ED56: "F0ED56",
      };

      return color_map[payload];
    },
    tableConfig: () =>
      createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      }),
    list: function () {
      return this.costsList || [];
    },

    headers: () => [
      createTableHeader("left_options", { mw: 25, ta: "center" }),
      createTableHeader("main_costs", { f: 1.2 }),
      createTableHeader("creditor"),
      createTableHeader("date_string", { mw: 100 }),
      createTableHeader("costgroups"),
      createTableHeader("main_subject"),
      createTableHeader("amount_net", { ta: "right", f: 0.5, minw: 120 }),
      // createTableHeader("status", { mw: 50, ta: "center" }),
      createTableHeader("printer", { text: false, mw: 80, ta: "center" }),
      createTableHeader("options", { text: false, mw: 30 }),
    ],
    costGroupTV: function () {
      return createTV(
        this.costData?.costgroups,
        "cost_group_name",
        "cost_group_id"
      );
    },
    invoice_projectsTV: function () {
      return createTV(
        this.costData?.invoice_projects,
        "invoice_project_name",
        "invoice_project_id"
      );
    },
    costDetailsFlag: function () {
      return childOfOrEqualDetails(costListLDTRoutes, this.$route);
    },
    inv_statTV: function () {
      console.log({ "cost-list.vue:361 this.costData": this.costData });
      return this.costData?.invoice_status
        ? this.costData?.invoice_status.map((e) => ({
            text: this.$t(e[0]),
            value: e[1],
          }))
        : [];
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },

    // FetchList and Advanced Search Computed
    advancedSearchData: function () {
      return {
        invoice_projectsTV: this.invoice_projectsTV,
        invoice_statusTV: this.cost_invoice_statusTV,
        costGroupTV: this.costGroupTV,
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, costsActions),
    getInvoiceStatColor: getInvoiceStatColor,
    getInCoStatusColor: getInCoStatusColor,
    async fetchCostData() {
      this[ActionTypes.CostData.FETCH.ALL]();
      // const costAddData = await CostsService.findCostData();
      // this.costData = costAddData.data;
      // console.log("costAddData", costAddData);
    },
    defaultBasicFilter() {
      return {
        searchString: undefined,
        cost_group_id: undefined,
        invoice_project_id: undefined,
        status_colors: undefined,
      };
    },
    onInvoicePrintClick: (item) => {
      const { invoice_id } = item;
      openWindow(
        `${HttpClient.getBaseUrl()}/accounting.pl?section=costs&action=print_costs&invoice_id=${invoice_id}`,
        "Print Invoice",
        { wr: 0.7, hr: 0.7 }
      );
    },
    refresh: async function () {
      await this.fetchList();
      this.$refs.costListTable.resetScroll();
    },
    onAddCostClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "new_cost",
        },
      });
    },

    onAdded: function (payload) {
      this.refresh();
      this.onDialogCancelled();
      this.onCostClicked(payload);
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAddCostListClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "new_cost",
        },
      });
    },

    // NEW

    onCostDelete: async function (item) {
      const confirmationResult = await confirmDelete("Cost", item.external_ref);
      if (confirmationResult === "OK") {
        this[ActionTypes.CostsList.DELETE.SINGLE](item);
      }
    },

    // Start Sidewindow
    onCostClicked: function (e,cost) {
      if (["left_options", "dt-checkbox v2 s1", "invoice-select-cb"].includes( e.target.className )) {
        return;
      }
      this.selectedClickedInvoice = cost;
      this.$router.push({
        name: costListLDTRoutes.names.tab,
        params: {
          invoice_id: cost.invoice_id,
          tab: "overview",
        },
      });
    },
    onInvoicePDFClick: async function (item) {
      if (this.singlePDFDownloadingID > 0) {
        return;
      }
      
      const { invoice_id, invoice_ref, external_ref } = item;
      this.singlePDFDownloadingID = invoice_id;

      const filename = `${external_ref}.pdf`;
      const printURL = `${HttpClient.getBaseUrl()}/accounting.pl?section=invoices&action=print_invoice&invoice_id=${invoice_id}`;

      await downloadPDF(printURL, this.$store.getters.account, filename);
      this.singlePDFDownloadingID = 0;
    },
    onCloseCostDetails: function () {
      this.selectedClickedCost = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: costListLDTRoutes.names.list,
        });
      });
    },

    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },
    fetchAdvancedSearchData: async () => {
      console.log("fetchAdvancedSearchData");
    },
    onHeaderCheckboxChanged(e) {
      if (this.headerCheckboxIcon == "checkbox-tick") {
        this.checkedCostsID = [];
      } else {
        this.checkedCostsID = this.list.map((r) => r.invoice_id);
      }
    },
    onSelectCost: function (e, type, item) {
      const checked = e.target.checked;

      if (type == "cost") {
        if (checked) {
          this.checkedCostsID = [...this.checkedCostsID, item.invoice_id];
        } else {
          this.checkedCostsID = this.checkedCostsID.filter(
            (r) => r != item.invoice_id
          );
        }
      }
    },
    batchPDFDownloadRequest: async function (e, type, item) {
      const invoice_ids = this.checkedCostsID.join();
      // console.log('mdsir: invoice_ids', invoice_ids);
      this.batchPDFDownloadLoading = true;
      const { domain_tld } = HttpClient.getBaseURLObject();
      const res = await InvoicesService.batchPDFDownload({
        type: "cost",
        ids: invoice_ids,
        domain_tld,
      });
      NotificationService.showNotification({
        text: this.$t('pdf_download_processing_message'),
        timeout: 10000,
      });
      this.batchPDFDownloadLoading = false;
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-accounting-costs-costs_list {
  .dt-ntable.costs-list {
    td:first-child {
      flex: 0.6;
      font-weight: 700;
    }
  }
  .dt-page--body {
    --offset: 190px;
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .search {
      .dt-checkbox-control {
        .dt-checkbox-label {
          color: var(--text-accent);
          font-weight: 500;
        }
      }
    }
  }
}

.status {
  flex: 1;
  display: flex;
  align-items: center;
  max-width: 150px;
  .square {
    width: 15px;
    height: 15px;
    margin-right: 10px;
    border: 1px solid;
  }
}
</style>


